// extracted by mini-css-extract-plugin
export default {"loanform":"Loanform_loanform__OTjuG","notfound":"Loanform_notfound__66cFx","warning":"Loanform_warning__J-H1o","loading":"Loanform_loading__5xtKx"};